import script from "./AuPopper.vue?vue&type=script&setup=true&lang=js"
export * from "./AuPopper.vue?vue&type=script&setup=true&lang=js"

import "./AuPopper.vue?vue&type=style&index=0&id=ae78a8cc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae78a8cc"]])

export default __exports__